import { Component, OnInit, ViewChild } from '@angular/core';
import { Prescriptor } from '../../models/prescriptor.model';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrescriptorService } from '../../services/prescriptor.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogRef } from '@angular/material';
import { Location } from '@angular/common';
import { TasacionesService } from '../../services/tasaciones.service';
import { ModelHelpers } from '../../models/ModelHelpers';
import { TipoEntidadEnum } from '../../models/enums';
import { ArchivosService } from '../../services/archivos.service';
import { AgUploadTemporalFilesComponent } from '../ag-upload-temporal-files/ag-upload-temporal-files.component';
import { ApiResult } from '../../models/ApiResult';
import { ToastrService } from 'ngx-toastr';
import { GlobalService } from '../../services/global.service';
import { error } from 'console';

@Component({
  selector: 'app-prescriptor-edit',
  templateUrl: './prescriptor-edit.component.html',
  styleUrls: ['./prescriptor-edit.component.scss']
})

export class PrescriptorEditComponent implements OnInit {

  prescriptorForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  contratosList: any;
  salesPersonList: any;
  categorias: any;
  responsablesCuentas: any;
  contactos: any;
  model: any;
  tipoEntidad = TipoEntidadEnum[TipoEntidadEnum.Prescriptor];
  archivos: any[];
  comunidades: any[] = [];
  provincias: any[] = [];

  @ViewChild('fileUpload', { static: false }) fileUpload: AgUploadTemporalFilesComponent;

  constructor(
    private _fb: FormBuilder,
    private _avRoute: ActivatedRoute,
    private _PrescriptorService: PrescriptorService,
    private _authService: AuthService,
    private _router: Router,
    public dialogRef: MatDialogRef<PrescriptorEditComponent>,
    private _TasacionesService: TasacionesService,
    private _location: Location,
    private _fileService: ArchivosService,
    private toastrService: ToastrService,
    private _globalService: GlobalService
  ) {
    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.prescriptorForm = this._fb.group({
      id: 0,
      descripcion: [''],
      ciudad: [''],
      retribuido: [false],
      // contratoID: [null],
      salesPersonCode: [''],
      categoriaId: [null],
      empresa: [''],
      direccion: [''],
      codPostal: [''],
      comunidadAutonomaId: [''],
      provinciaId: [''],
      // provinciaId: new FormControl({ value: '', disabled: true }),
      pais: [''],
      tipoRetribucion: [''],
      observaciones: [''],

      // updatedBy: [''],
      // createdBy: [''],
      updatedDate: [''],
      createdDate: [new Date()],
      createdByName: [''],
      updatedByName: ['']
    });
  }
  

  ngOnInit() {

    this.loadCombos();
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      this._PrescriptorService.getPrescriptorById(this.id)
        .subscribe(resp => {
          this.model = resp;
          // console.log(resp)
          this.prescriptorForm.patchValue(this.model);
        }, error => { this.errorMessage = error; });

      this.refreshArchivos();

    } else {
      this.model = new Prescriptor();
      this.isNewElement = true;
    }
    // console.log(this.id);

    //var a = this.prescriptorForm.get('comunidadAutonomaId').valueChanges.subscribe();

    this.prescriptorForm.get('comunidadAutonomaId').valueChanges.subscribe(comunidadId => {
      this.provincias = []; // Limpiamos las provincias al cambiar la comunidad
      this.prescriptorForm.get('provinciaId').setValue(null); // Limpiamos la provincia seleccionada
      if (comunidadId) {
        this.loadProvincias(comunidadId);
        this.prescriptorForm.get('provinciaId').enable();
      } else {
        this.prescriptorForm.get('provinciaId').disable();
      }
    });

  }


  loadCombos() {
    this._TasacionesService.getContratos().subscribe(data => this.contratosList = data);
    this._TasacionesService.getSalesPerson().subscribe(data => this.salesPersonList = data);
    this._PrescriptorService.getCategoriasList().subscribe(data => this.categorias = data);
    this._globalService.getComunidades().subscribe(
      data => this.comunidades = data,
      error => console.error('Error al cargar las comunidades: ', error)
    );
  }

  loadProvincias(comunidadId: number) {
    this._globalService.getProvincias(comunidadId).subscribe(
      data => this.provincias = data,
      error => console.error('Error al cargar las provincias: ', error)
    )
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  setContactos(contactos) {
    this.contactos = contactos;
    // console.log(contactos)
  }

  save() {
    if (!this.prescriptorForm.valid) {
      return;
    }

    ModelHelpers.copyFromForm(this.prescriptorForm.value, this.model);
    // console.log(this.model);
    this.model.contactos = this.contactos;

    if (this.isNewElement) {
      this._PrescriptorService.post(this.model)
        .subscribe((data: ApiResult) => {
          this.fileUpload.onClickSubmit(data.mensaje)
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
          this.toastrService.success('Guardado correctamente', 'Cerrar');
        }, error => {
          this.errorMessage = error;
          const mensaje = error && error.error && error.error.mensaje ? error.error.mensaje : 'Error al guardar prescriptor';
          this.toastrService.error(mensaje, 'Cerrar');
        });
    } else {
      let response = this._PrescriptorService.put(this.model)
        .subscribe((data: ApiResult) => {

          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
          this.toastrService.success('Guardado correctamente', 'Cerrar');
        }, error => {
          this.errorMessage = error;
          const mensaje = error && error.error && error.error.mensaje ? error.error.mensaje : 'Error al guardar prescriptor';
          this.toastrService.error(mensaje, 'Cerrar');
        });
    }
  }

  get nombre() { return this.prescriptorForm.get('descripcion'); }

  onFileUploaded(event) {
    this.refreshArchivos();

  }

  refreshArchivos() {
    this._fileService.getArchivos(this.id, TipoEntidadEnum[TipoEntidadEnum.Prescriptor]).subscribe(x => {
      this.archivos = x;
      // console.log(this.archivos);
    });
  }
}

